'use client';

import * as React from 'react';
import * as AvatarPrimitive from '@radix-ui/react-avatar';

import { cn } from '@/helpers/shadcn';

function Avatar({ className, ...props }) {
  return <AvatarPrimitive.Root data-slot="avatar" className={cn('relative flex size-8 shrink-0 overflow-hidden rounded-full', className)} {...props} />;
}

function AvatarImage({ className, ...props }) {
  return <AvatarPrimitive.Image data-slot="avatar-image" className={cn('aspect-square size-full', className)} {...props} />;
}

// The initials sit in their own box so `text-box` can trim it to cap-height/baseline.
// Centring the raw text centres the *em* box instead, and the descender space nothing
// fills pushes capitals visibly high — about a pixel here, and worse on macOS, where
// the system font's descent is far deeper than the height its capitals reach.
// `text-box` is ignored where it is unsupported, which leaves today's behaviour.
function AvatarFallback({ className, children, ...props }) {
  return (
    <AvatarPrimitive.Fallback data-slot="avatar-fallback" className={cn('bg-muted border flex size-full items-center justify-center rounded-full', className)} {...props}>
      <span className="[text-box:trim-both_cap_alphabetic]">{children}</span>
    </AvatarPrimitive.Fallback>
  );
}

export { Avatar, AvatarImage, AvatarFallback };
